import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken, getUserRoleFromToken, parseJwt } from './utils/auth';

function ProtectedRoute({ children, allowedRoles }) {
  const token = getToken();
  if (!token) {
    return <Navigate to="/" replace />;
  }

  const payload = parseJwt(token);
  if (!payload) {
    return <Navigate to="/" replace />;
  }

  const userRole = getUserRoleFromToken(token);

  if (allowedRoles.includes(userRole)) {
    return children;
  }

  if (userRole === 'TechnicalServiceManager') {
    return <Navigate to="/grouptracking" replace />;
  }

  if (userRole === 'TechnicalServicePersonnel') {
    return <Navigate to="/technical-service/my-jobs" replace />;
  }

  if (userRole === 'TechnicalServiceAccountant') {
    return <Navigate to="/technical-service/archive" replace />;
  }

  if (userRole === 'Partner') {
    return <Navigate to="/partner" replace />;
  }

  if (userRole === 'Accountant' || userRole === 'RentalAccountant') {
    return <Navigate to="/accounting" replace />;
  }

  return <Navigate to="/grouptracking" replace />;
}

export default ProtectedRoute;
